import type { SpatialLevel } from "@station/domain/models/spatial-level.model";
import type { SearchResult } from "@weather/presentation/pages/weather/weather.page";

const MAX_SUGGEST_RESULTS = 10;

/**
 * Gets the list of stations from the spatial levels.
 */
function getAllStations(
    levels: readonly Readonly<SpatialLevel>[],
): SearchResult[] {
    const results: SearchResult[] = [];

    const processLevel = (level: Readonly<SpatialLevel>): void => {
        level.stations.forEach((station) => {
            results.push({
                label: station.displayName,
                id: station.id.valueOrThrow,
                icon: station.icon,
                isStation: true,
                latitude: station.latitude.length ? station.latitude : null,
                longitude: station.longitude.length ? station.longitude : null,
            });
        });

        level.children?.forEach(processLevel);
    };

    levels.forEach(processLevel);

    return results;
}

/**
 * Gets the initial suggestions for the search.
 */
export function getInitialSuggestions(
    levels: readonly Readonly<SpatialLevel>[],
): SearchResult[] {
    const all = getAllStations(levels);

    const validStations = all.filter(
        (station) => station.isStation && station.latitude && station.longitude,
    );

    if (validStations.length <= MAX_SUGGEST_RESULTS) {
        return validStations;
    }

    return validStations
        .sort((stationA, stationB) =>
            stationA.label.localeCompare(stationB.label),
        )
        .slice(0, MAX_SUGGEST_RESULTS);
}
